export default "__VITE_ASSET__TYDPmO4j__"